import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { EventsAwardsLandingPageContext } from "@events-awards/utils/types";
import { Route } from "@route-types/Section/layouts/EventsAwards/DTA/+types/EventsAwardsDTAPage";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsDTAPageData } from "./EventsAwardsDTAPage.server";
import EventsAwardsDTAPageContent from "./EventsAwardsDTAPageContent";

/** This is the main entry point component for /events-awards/sustainability-impact-awards route. */
const EventsAwardsDTAPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsLandingPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <EventsAwardsDTAPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default EventsAwardsDTAPage;

export const loader = async () => await fetchEventsAwardsDTAPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as EventsAwardsLandingPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
